import { getLoginType } from "@/libs/until";
const state = {
  activityList: {
    content: []
  },
  activityCount: [],
  activityDetail: {},
  activityPerson: [],
  activitySetting: [],
  cat: {
    list: []
  }
}
const	getters = {
	getUserLoginType: state => {
		const logintype = getLoginType();
		return logintype;
	},
  getActivityPerson: state => {
    let res = [...state.activityPerson]

    function loop(data) {
      for(let i of data) {
        if(i.type === 'dept' && !i.children) {
          i.disabled = true;
        }
        if(i.children && i.children.length > 0) {
          delete i.value;
          loop(i.children);
        }else {
          continue;
        }
      }
    }
    loop(res)
    return res;
  },
  getActivityCat: state => {
    return state.cat.list;
  },
  getActivityDetail: state => {
    return state.activityDetail;
  },
  getActivityList: state => {
    let activities = state.activityList.content;
    if(activities.length) {
      for(let a of activities) {
        if(a.product_info && a.product_info.indexOf('/null') !== -1) {
          a.product_info = a.product_info.replace('/null', '');
        }
      }
    }
    return activities;
  },
  getActivitySetting: state => {
    let res = [];
    let setting = state.activitySetting;
    for(let i in setting) {
      if(setting[i].title) {
        let obj = {
          children: []
        };
        obj.title = setting[i].title;
        if(Array.isArray(setting[i].data)) {
          for(let j of setting[i].data) {
            obj.children.push(j);
          }
        }
        res.push(obj);
      }
    }
    return res;
  },
  activityCount: state => {
    let arr=[
      {
        name: `全部`,
        label: `全部 (${state.activityCount.allbmc_count || 0})`,
        value: state.activityCount.allbmc_count,
        type:1,
      },
      {
        name: `待审批`,
        label: `待审批 (${state.activityCount.wbmc_count || 0})`,
        value: state.activityCount.wbmc_count,
        type:2
      },
      {
        name: `审批中`,
        label: `审批中 (${state.activityCount.ebmc_count || 0})`,
        value: state.activityCount.ebmc_count,
        type:6
      },
      {
        name: `已审批`,
        label: `已审批 (${state.activityCount.okbmc_count || 0})`,
        value: state.activityCount.okbmc_count,
        type:3
      },
      {
        name: `抄送我的`,
        label: `抄送我的 (${state.activityCount.ul_count || 0})`,
        value: state.activityCount.ul_count,
        type:5
      },
    ]
    if(JSON.parse(localStorage.getItem('userData')).logintype!== "HCM") {
      return arr
    }else {
      return arr.slice(0, 4)
    }
  },
}
const	mutations = {
  getactivitycat(state,payLoad){
    state.cat = payLoad;
  },
  getplateform(state,payLoad){
    state.plateform = payLoad;
  },
  getactivitylist(state, payload) {
    state.activityList = payload;
  },
  getactivitycount(state, payload) {
    state.activityCount = payload;
  },
  getactivitydetail(state, payload) {
    state.activityDetail = payload;
  },
  getactivityperson(state, payload) {
    state.activityPerson = payload;
  },
  getactivitysetting(state, payload) {
    state.activitySetting = payload;
  },
}
const	actions = {
  reqActivitySetting( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/hcmCustomModel/getListByCampaign",
				method: "get",
				params
      }).then((res) => {
        commit('getactivitysetting', res.data);
        r(res.data);
      }).catch(() => {
        j();
      })
    })

  },


  reqActivityApproval( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/campgign/saveCamExamine",
        method: "post",
        params: params,
        noFormat: true,
        responseType: "json"
      }).then((res) => {
        r(res);
      }).catch(() => {
        j();
      })
    })

  },

  reqActivityPeople( { commit } ) {
		return new Promise(r => {
			fetch({
				url: "hcm/userout/getAllUserTreeByDepartId",
				method: "get",
				noFormat: true,
				responseType: "text"
			}).then(res => {
				let result = JSON.parse(res);
				commit('getactivityperson', result.data);
				r();
			})
		})
  },

  reqActivityDetail( { commit }, params) {
    return new Promise( (r, j) => {
      fetch({
        url: "hcm/campgign/findCampaignDetailExamine",
        method: "get",
        params: params,
      }).then(res => {
        commit('getactivitydetail', res.data);
        r(res.data)
      })
    })
	},
	
	reqActivityCcDetail( { commit }, params) {
    return new Promise( (r, j) => {
      fetch({
        url: "hcm/campgign/findCampaignDetailExaminecc",
        method: "get",
        params: params,
      }).then(res => {
        commit('getactivitydetail', res.data);
        r(res.data)
      })
    })
  },

  reqActivityList( { commit }, params ) {

    fetch({
      url: "hcm/wechat/findPageCampaignsbmcWecat",
      method: "get",
      params: params,
      noFormat: true,
      responseType: "text"
    }).then(res => {
      let result = JSON.parse(res);
      commit('getactivitylist', result.data);
    })
  },

  reqActivityCount( { commit }, params ) {
    fetch({
      url: "hcm/campgign/findCamCountToCheckweb",
      method: "get",
      params: params,
      noFormat: true,
      responseType: "text"
    }).then(res => {
      let result = JSON.parse(res);
      commit('getactivitycount', result.data);
    })
  },

  reqActivityCat( { commit }, params ) {
    fetch({
      url: "hcm/ProductClassify/seletProductClassify?pageNum=1&pageSize=100",
      method: "get",
      params: params,
    }).then(res => {
      commit('getactivitycat', res.data.data);
    })
  },
  getHcmApprovalByRelated({commit},params){
    return new Promise((r, j) => {
      fetch({
        url: "hcm/hcmApproval/getHcmApprovalByCampaign",
        method: "get",
        params:params
      }).then((res) => {
        r(res.data);
      }).catch(() => {
        j();
      })
    })
  }

}

export default {
  state,
  getters,
  mutations,
  actions
}
